import { useCallback, useState } from 'react';
import type { ReactNode } from 'react';
import { ToastCtx } from '../../hooks/useToast';
import styles from './Toast.module.css';

export type ToastLevel = 'info' | 'success' | 'warn' | 'error';
interface ToastItem { id: number; level: ToastLevel; message: string }

let _id = 0;
const PREFIX: Record<ToastLevel, string> = {
  info:    '◈',
  success: '✓',
  warn:    '⚠',
  error:   '✗',
};

export function ToastProvider({ children }: { children: ReactNode }) {
  const [items, setItems] = useState<ToastItem[]>([]);

  const toast = useCallback((level: ToastLevel, message: string) => {
    const id = ++_id;
    setItems(prev => [...prev.slice(-4), { id, level, message }]);
    setTimeout(() => setItems(prev => prev.filter(t => t.id !== id)), 5000);
  }, []);

  return (
    <ToastCtx.Provider value={{ toast }}>
      {children}
      <div className={styles.container}>
        {items.map(item => (
          <div key={item.id} className={[styles.toast, styles[item.level]].join(' ')}>
            <span className={styles.ts}>{new Date().toLocaleTimeString('en-US', { hour12: false })}</span>
            <span className={styles.prefix}>{PREFIX[item.level]}</span>
            <span className={styles.msg}>{item.message}</span>
            <button className={styles.close} onClick={() => setItems(p => p.filter(t => t.id !== item.id))}>✕</button>
          </div>
        ))}
      </div>
    </ToastCtx.Provider>
  );
}
